import { User } from "../Definitions/Generated/User";
import { RouterAction } from "connected-react-router";
import { ThemeTypes } from "../Definitions/Definitions";

export enum ActionTypes {
    SET_CURRENT_USER = "SET_CURRENT_USER",
    SET_AUTHENTICATED = "SET_AUTHENTICATED",
    OPEN_SNACKBAR = "OPEN_SNACKBAR",
    CLOSE_SNACKBAR = "CLOSE_SNACKBAR",
    SET_PAGE_THEME = "SET_PAGE_THEME",
}

export type Action = RouterAction | setCurrentUserAction | setAuthenticatedAction | openSnackbarAction | closeSnackbarAction | setPageTheme;
export interface setCurrentUserAction {
    type: ActionTypes.SET_CURRENT_USER;
    currentUser: User;
}

export interface setAuthenticatedAction {
    type: ActionTypes.SET_AUTHENTICATED;
    authenticated: boolean;
}

export interface openSnackbarAction {
    type: ActionTypes.OPEN_SNACKBAR;
    status: number;
    message: string;
    closeDelay: number;
}

export interface closeSnackbarAction {
    type: ActionTypes.CLOSE_SNACKBAR;
}

export interface setPageTheme {
    type: ActionTypes.SET_PAGE_THEME;
    theme: ThemeTypes;
}